(function () {
  'use strict';

  if (window.PCAnimatedLogo) return;

  var selector = '[data-pc-animated-logo]';
  var logoObservers = new WeakMap();
  var activeRuns = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cancel(root) {
    var run = activeRuns.get(root);
    if (!run) return;
    if (run.timer) window.clearTimeout(run.timer);
    if (run.target && run.onEnd) run.target.removeEventListener('animationend', run.onEnd);
    activeRuns.delete(root);
  }

  function complete(root) {
    cancel(root);
    var observer = logoObservers.get(root);
    if (observer) {
      observer.disconnect();
      logoObservers.delete(root);
    }
    var stage = root.closest && root.closest('[data-pc-logo-stage]');
    root.classList.remove('is-armed', 'is-playing');
    root.classList.add('is-complete');
    if (stage) {
      stage.classList.remove('is-logo-armed', 'is-logo-playing');
      stage.classList.add('is-logo-complete');
    }
  }

  function completionSpec(root) {
    var stage = root.closest && root.closest('[data-pc-logo-stage]');
    var declaredTarget = stage && stage.querySelector('[data-pc-logo-complete-on]');
    if (declaredTarget) {
      return {
        target: declaredTarget,
        animation: declaredTarget.getAttribute('data-pc-logo-complete-on'),
        timeout: parseInt(declaredTarget.getAttribute('data-pc-logo-timeout'), 10) || 2600
      };
    }

    if (root.classList.contains('pc-alogo--footer')) {
      return {
        target: root.querySelector('.pc-alogo__mark'),
        animation: 'pcALogoShine',
        timeout: 3800
      };
    }

    if (root.classList.contains('pc-alogo--human')) {
      return {
        target: root.querySelector('.pc-alogo__connector'),
        animation: 'pcALogoConnectorIn',
        timeout: 3000
      };
    }

    var connector = root.querySelector('.pc-alogo__connector');
    if (connector) {
      return { target: connector, animation: 'pcALogoConnectorIn', timeout: 2200 };
    }

    return {
      target: root.querySelector('.pc-alogo__top'),
      animation: 'pcALogoTopIn',
      timeout: 1300
    };
  }

  function trackCompletion(root) {
    cancel(root);
    var spec = completionSpec(root);
    var run = { target: spec.target, onEnd: null, timer: null };
    var finish = function () {
      if (activeRuns.get(root) !== run) return;
      complete(root);
    };
    var onEnd = function (event) {
      if (event.target !== spec.target || event.animationName !== spec.animation) return;
      finish();
    };

    run.onEnd = onEnd;
    if (spec.target) spec.target.addEventListener('animationend', onEnd);
    run.timer = window.setTimeout(finish, spec.timeout);
    activeRuns.set(root, run);
  }

  function play(root, options) {
    if (!root) return;
    var force = options && options.force === true;
    if (!force && root.getAttribute('data-pc-logo-played') === 'true') return;
    root.setAttribute('data-pc-logo-played', 'true');

    if (prefersReducedMotion()) {
      complete(root);
      return;
    }

    root.classList.remove('is-complete');
    root.classList.add('is-playing');
    var stage = root.closest && root.closest('[data-pc-logo-stage]');
    if (stage) {
      stage.classList.remove('is-logo-complete');
      stage.classList.add('is-logo-playing');
    }
    trackCompletion(root);
  }

  function reset(root) {
    if (!root) return;
    cancel(root);
    root.removeAttribute('data-pc-logo-played');
    root.classList.remove('is-playing', 'is-complete');
    root.classList.add('is-armed');
    var stage = root.closest && root.closest('[data-pc-logo-stage]');
    if (stage) {
      stage.classList.remove('is-logo-playing', 'is-logo-complete');
      stage.classList.add('is-logo-armed');
    }
  }

  function replay(root) {
    if (!root) return;
    if (prefersReducedMotion()) {
      root.setAttribute('data-pc-logo-played', 'true');
      complete(root);
      return;
    }
    reset(root);
    void root.offsetWidth;
    play(root, { force: true });
  }

  function watch(root) {
    if (prefersReducedMotion()) {
      complete(root);
      return;
    }

    root.classList.add('is-armed');
    var stage = root.closest && root.closest('[data-pc-logo-stage]');
    if (stage) stage.classList.add('is-logo-armed');

    if (!('IntersectionObserver' in window)) {
      play(root);
      return;
    }

    var context = root.getAttribute('data-pc-logo-context');
    var threshold = context === 'cta' || context === 'human' ? 0.8 : 0.55;
    var target = stage || root;
    var localObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < threshold) return;
        localObserver.disconnect();
        logoObservers.delete(root);
        play(root);
      });
    }, { threshold: threshold, rootMargin: '0px 0px -10% 0px' });

    logoObservers.set(root, localObserver);
    localObserver.observe(target);
  }

  function markAutoplay(root) {
    play(root);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(selector + ':not([data-pc-logo-init])').forEach(function (logo) {
      logo.setAttribute('data-pc-logo-init', 'true');
      logo.addEventListener('pc:logo:play', function () { play(logo); });

      var trigger = logo.getAttribute('data-pc-logo-trigger');
      if (trigger === 'view') watch(logo);
      else if (trigger === 'load') markAutoplay(logo);
    });
  }

  window.PCAnimatedLogo = { init: init, play: play, replay: replay, reset: reset, cancel: cancel };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
